"use client";

import { Heading1Text, Logo } from "@gnist/design-system";
import { styled } from "styled-components";
import type { LogoBrand } from "@gnist/design-system/foundation/logos/types.js";
import React from "react";
import { getThemeFromDealerName } from "@/design-system/ThemeProvider";
import { tokens } from "@gnist/themes/tokens.css.js";

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${tokens.spacing.xs};
  margin-inline: auto;
  max-width: 672px;
  text-align: center;
  margin-bottom: ${tokens.spacing.m};
`;

interface Props {
  departmentName: string;
  departmentSlug?: string;
}

export const HeadSection = ({ departmentName, departmentSlug }: Props) => {
  const theme = () => departmentSlug && getThemeFromDealerName(departmentSlug);

  return (
    <HeadWrapper>
      {theme() !== "bilhold" ? (
        <Logo size="xxl" type="wordmark" brand={theme() as LogoBrand} />
      ) : (
        <Heading1Text>{departmentName}</Heading1Text>
      )}
    </HeadWrapper>
  );
};
